// api.js

import axiosInstance from "../axiosInstance";

export const roleService = {
  create: async (obj) => {
    try {
      let response = await axiosInstance.post("/role", obj);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  fetch: async (limit, skip, search = "") => {
    try {
      let api = `/role?&$limit=${limit || 15}&$skip=${skip || 0}`;
      if (search) {
        api += `&name[$search]=${search}`;
      }
      let response = await axiosInstance.get(api);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  edit: async (id, obj) => {
    try {
      let response = await axiosInstance.patch(`/role/${id}`, obj);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  delete: async (id) => {
    try {
      let response = await axiosInstance.delete(`/role/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};
